export default __webpack_public_path__ + "static/media/limb_big@2x.ae121c94.webp";